import {createReducer, on} from '@ngrx/store';
import {clearDeleteManyClipsState, deleteManyClips, deleteManyClipsFailure, deleteManyClipsSuccess} from './clip.delete-many.actions';


export interface State {
  record: null;
  error: any | null;
  loaded: boolean;
  loading: boolean;
}

export const initialState: State = {
  record: null,
  error: null,
  loaded: false,
  loading: false
};


export const deleteManyClipsReducer = createReducer(
  initialState,

  on(deleteManyClips, (): State => ({
    record: null,
    error: null,
    loaded: false,
    loading: true
  })),
  on(deleteManyClipsSuccess, (): State => ({
    record: null,
    error: null,
    loaded: true,
    loading: false
  })),
  on(deleteManyClipsFailure, (_state: State, action): State => ({
    record: null,
    error: action.error,
    loaded: false,
    loading: false
  })),
  on(clearDeleteManyClipsState, (): State => ({
    record: null,
    error: null,
    loaded: false,
    loading: false
  }))
);

